import React from 'react'

export default React.createClass({

  render: function() {
    let show = [];
      show.push(
        <div key={'key'} style={{padding: 20}}>
            <h3 style={{fontWeight: 300, textAlign: 'center', marginBottom: 10, color: '#0285a7'}}>{this.props.data.label}</h3>
            <p>{this.props.data.question}</p>
        </div>
    )
    return (
      <div >
        <div style={{background: 'white'}}>
          {show}
        </div>
      </div>
    )}
})



// WEBPACK FOOTER //
// ./src/components/support/answers.jsx